<!-- Header -->
<div class="tw-flex tw-mb-6">
  <mg-btn
    class="tw-ml-auto"
    variant="filled"
    [responsive]="true"
    (pressed)="openRestrictionsEditModal()">
    {{ MSG.CREATE_PARTY_GROUP }}
  </mg-btn>
</div>

<!-- Main Content -->
<div class="tw-flex tw-flex-column md:tw-flex-row tw-gap-8">
  <div class="left-content">
    <div class="tw-flex tw-flex-column tw-grow tw-gap-3">
      <div class="tw-flex tw-items-center tw-gap-1">
        <mg-text variant="header-md-secondary">{{ MSG.NO_PARTY_GROUP_HEADER }}</mg-text>
        <mg-tooltip [label]="MSG.NO_PARTY_GROUP_TOOLTIP"></mg-tooltip>
      </div>
      <mg-membership-list-table
        [types]="NO_PARTY_LIST_TYPE"
        [descriptions]="false"
        [canChangeName]="true"
        [canChangeStatus]="true"
        [flag]="NO_PARTY_FLAG"
        [refreshList]="refreshNPListSubject.asObservable()"
        [editListFn]="openRestrictionsEditModal.bind(this)">
        <ng-template #emptyState>
          <mg-empty-state
            [title]="MSG.NO_PARTY_GROUP_EMPTY_STATE_TITLE"
            [subtitle]="MSG.NO_PARTY_GROUP_EMPTY_STATE_SUBTITLE"
            [actionButtonLabel]="MSG.NO_PARTY_GROUP_EMPTY_STATE_BUTTON"
            (handleAction)="openRestrictionsEditModal()">
          </mg-empty-state>
        </ng-template>
      </mg-membership-list-table>
    </div>
  </div>
  <div class="right-content">
    <div class="tw-flex tw-flex-column tw-grow tw-gap-3">
      <mg-text variant="header-md-secondary">{{ MSG.REGISTRATION_LIST_HEADER }}</mg-text>
      <mg-membership-list-table
        [types]="NO_PASS_LIST_TYPES"
        [hideHeader]="true">
      </mg-membership-list-table>
    </div>
  </div>
</div>
